import { render, staticRenderFns } from "./Favoritos.vue?vue&type=template&id=331f1ddc&scoped=true&"
import script from "./Favoritos.vue?vue&type=script&lang=js&"
export * from "./Favoritos.vue?vue&type=script&lang=js&"
import style0 from "./Favoritos.vue?vue&type=style&index=0&id=331f1ddc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331f1ddc",
  null
  
)

export default component.exports